import { Button } from '@mui/material'

const signUpButtonStyles = {
  background: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
  color: 'white',
  fontWeight: 600,
  fontSize: '13.33px',
  textTransform: 'none' as const,
  borderRadius: '8px',
  py: 1.5,
  mt: 1,
  border: 0,
  lineHeight: '150%',
  letterSpacing: '0.15px',
  '&:hover': {
    background: 'linear-gradient(135deg, #3a1766 0%, #a5006a 100%)',
  },
}

interface ContactCtaButtonProps {
  talkToAnExpertUrl: string
}

export const ContactCtaButton = ({ talkToAnExpertUrl }: ContactCtaButtonProps) => {
  const handleContactClick = () => {
    window.open(talkToAnExpertUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Button fullWidth variant='contained' sx={signUpButtonStyles} onClick={handleContactClick}>
      Contact us for your deliveries
    </Button>
  )
}
